module.exports = __webpack_public_path__ + "img/2.00875ccc.jpg";